export const GET_ZONE_RATE_SUCCESS = 'GET_ZONE_RATE_SUCCESS';
export const GET_ZONE_RATE_REQUEST = 'GET_ZONE_RATE_REQUEST';
export const GET_ZONE_RATE_FAILURE = 'GET_ZONE_RATE_FAILURE';
export const GET_ZONE_RATE_REST = 'GET_ZONE_RATE_REST';
export const getZoneRateSuccess = (payload) => ({
    type: GET_ZONE_RATE_SUCCESS,
    payload,
});
export const getZoneRateRequest = (payload) => ({
    type: GET_ZONE_RATE_REQUEST,
    payload,
});
export const getZoneRateFailure = (payload) => ({
    type: GET_ZONE_RATE_FAILURE,
    payload,
});
export const getZoneRateRest = () => ({
    type: GET_ZONE_RATE_REST,
});
